var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivitiesAligned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9645 20.2301L26.2355 20.3351L26.5066 20.2301L51.5599 10.5192L75.336 19.735C75.8172 19.9215 76.1343 20.3845 76.1343 20.9005V76.9085C76.1343 77.7871 75.2517 78.3915 74.4325 78.074L51.8309 69.3134L51.5599 69.2084L51.2888 69.3134L26.2355 79.0243L2.45937 69.8085C1.97823 69.622 1.66113 69.159 1.66113 68.643V12.635C1.66113 11.7564 2.54367 11.152 3.36289 11.4695L25.9645 20.2301Z",
    stroke: "url(#paint0_linear_8032_60291)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6543 13.5703L27.0679 22.328V76.1255L3.6543 67.3678V13.5703Z",
    fill: "url(#paint1_linear_8032_60291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4805 13.5703L27.0668 22.328V76.1255L50.4805 67.3678V13.5703Z",
    fill: "url(#paint2_linear_8032_60291)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4805 13.5703L73.8941 22.328V76.1255L50.4805 67.3678V13.5703Z",
    fill: "url(#paint3_linear_8032_60291)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6543 13.5703L27.0679 22.328V76.1255L3.6543 67.3678V13.5703Z",
    fill: "url(#paint4_linear_8032_60291)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 13.5703L73.8961 22.328V76.1255L50.4824 67.3678V13.5703Z",
    fill: "url(#paint5_linear_8032_60291)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8032_60291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6929 16.1858C73.6768 15.9238 73.6505 15.6624 73.6145 15.4027L73.6142 15.4008C73.6062 15.3436 73.5978 15.2867 73.5888 15.2299L73.5884 15.2268C73.5848 15.2041 73.5811 15.1813 73.5774 15.1586C73.4367 14.3039 73.1872 13.4703 72.837 12.6842C72.8284 12.6647 72.8197 12.6454 72.8109 12.6261C72.8011 12.6045 72.7913 12.5831 72.7814 12.5615C72.2667 11.4522 71.5521 10.4474 70.6847 9.60927C70.6648 9.58998 70.6448 9.57097 70.6247 9.55196C70.6185 9.54606 70.6123 9.54015 70.6061 9.53425C68.8718 7.90399 66.5967 7.00915 64.2862 7.00008C63.564 6.99706 62.8386 7.08072 62.125 7.2554C59.7219 7.84351 57.6003 9.4369 56.2915 11.618C55.6274 12.7246 55.179 13.9681 54.9806 15.2572C54.7642 16.6638 54.8783 18.0914 55.1678 19.4778C55.7124 22.0864 56.8551 24.5423 58.1576 26.8244C59.2929 28.8137 60.5867 30.7052 61.9801 32.5061C62.4029 33.0527 62.8355 33.5913 63.281 34.118C63.5138 34.3934 63.8075 34.8169 64.1404 34.9368C64.1852 34.9531 64.2482 34.9832 64.3019 34.995C64.3136 34.9976 64.325 34.9993 64.3356 34.9998C64.4128 35.0035 64.5119 34.959 64.5862 34.9305C64.6137 34.9199 64.6405 34.9073 64.6667 34.8932C64.672 34.8903 64.6772 34.8875 64.6823 34.8844C64.6852 34.8828 64.688 34.8813 64.6907 34.8797C64.6954 34.8768 64.7003 34.8739 64.705 34.871C64.7099 34.868 64.7149 34.8648 64.7199 34.8617C64.8088 34.8042 64.8904 34.7304 64.965 34.6532C64.9815 34.6359 64.9977 34.6186 65.0136 34.6013C65.0216 34.5925 65.0294 34.5839 65.0372 34.5753L65.0388 34.5734C65.1028 34.5018 65.1646 34.4279 65.2269 34.3548C65.3143 34.2518 65.401 34.1484 65.4872 34.0445C65.4885 34.0427 65.4899 34.041 65.4914 34.0393C65.511 34.0154 65.5307 33.9916 65.5503 33.9677C65.6443 33.8535 65.7379 33.7389 65.831 33.6238L65.833 33.6212C65.9967 33.4186 66.1584 33.2144 66.3187 33.0091C66.6865 32.5382 67.0472 32.061 67.4001 31.5774C67.7442 31.1041 68.0808 30.6248 68.4098 30.1402C68.6809 29.7412 68.9471 29.338 69.2072 28.9305C69.4839 28.4959 69.7536 28.0565 70.0159 27.6126C70.2563 27.2056 70.4919 26.7938 70.7203 26.3767C71.1327 25.6188 71.5195 24.8463 71.8745 24.0577C72.1167 23.5197 72.3483 22.9677 72.5608 22.4051C72.8159 21.7163 73.0391 21.0156 73.2229 20.3028C73.5667 18.9691 73.7761 17.5692 73.6929 16.1858ZM69.2126 21.0512C67.9894 22.5927 66.1546 23.4562 64.2862 23.465C63.5581 23.4686 62.8248 23.3421 62.1206 23.0756C59.628 22.1318 57.9167 19.5923 57.9167 16.8263C57.9167 16.4805 57.9422 16.1348 57.9936 15.7932C58.3994 13.0907 60.4382 10.8638 63.0074 10.3143C63.4327 10.2233 63.861 10.1802 64.2862 10.1821C66.4839 10.1915 68.5972 11.4005 69.7577 13.4002C71.1425 15.786 70.9162 18.9042 69.2126 21.0512Z",
    fill: "#F5BC23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8448 19.0098L69.8454 19.008M73.6929 16.1858C73.6768 15.9238 73.6505 15.6624 73.6145 15.4027L73.6142 15.4008C73.6062 15.3436 73.5978 15.2867 73.5888 15.2299L73.5884 15.2268C73.5848 15.2041 73.5811 15.1813 73.5774 15.1586C73.4367 14.3039 73.1872 13.4703 72.837 12.6842C72.8284 12.6647 72.8197 12.6454 72.8109 12.6261C72.8011 12.6045 72.7913 12.5831 72.7814 12.5615C72.2667 11.4522 71.5521 10.4474 70.6847 9.60927C70.6648 9.58998 70.6448 9.57097 70.6247 9.55196C70.6185 9.54606 70.6123 9.54015 70.6061 9.53425C68.8718 7.90399 66.5967 7.00915 64.2862 7.00008C63.564 6.99706 62.8386 7.08072 62.125 7.2554C59.7219 7.84351 57.6003 9.4369 56.2915 11.618C55.6274 12.7246 55.179 13.9681 54.9806 15.2572C54.7642 16.6638 54.8783 18.0914 55.1678 19.4778C55.7124 22.0864 56.8551 24.5423 58.1576 26.8244C59.2929 28.8137 60.5867 30.7052 61.9801 32.5061C62.4029 33.0527 62.8355 33.5913 63.281 34.118C63.5138 34.3934 63.8075 34.8169 64.1404 34.9368C64.1852 34.9531 64.2482 34.9832 64.3019 34.995C64.3136 34.9976 64.325 34.9993 64.3356 34.9998C64.4128 35.0035 64.5119 34.959 64.5862 34.9305C64.6137 34.9199 64.6405 34.9073 64.6667 34.8932C64.672 34.8903 64.6772 34.8875 64.6823 34.8844C64.6852 34.8828 64.688 34.8813 64.6907 34.8797C64.6954 34.8768 64.7003 34.8739 64.705 34.871C64.7099 34.868 64.7149 34.8648 64.7199 34.8617C64.8088 34.8042 64.8904 34.7303 64.965 34.6532C64.9815 34.6359 64.9977 34.6186 65.0136 34.6013C65.0216 34.5925 65.0294 34.5839 65.0372 34.5753L65.0388 34.5734C65.1028 34.5018 65.1646 34.4279 65.2269 34.3548C65.3143 34.2518 65.401 34.1484 65.4872 34.0445C65.4885 34.0427 65.4899 34.041 65.4914 34.0393C65.511 34.0154 65.5307 33.9916 65.5503 33.9677C65.6443 33.8535 65.7379 33.7389 65.831 33.6238L65.833 33.6212C65.9967 33.4186 66.1584 33.2144 66.3187 33.0091C66.6865 32.5382 67.0472 32.061 67.4001 31.5774C67.7442 31.1041 68.0808 30.6248 68.4098 30.1402C68.6809 29.7412 68.9471 29.338 69.2072 28.9305C69.4839 28.4959 69.7536 28.0565 70.0159 27.6126C70.2563 27.2056 70.4919 26.7938 70.7203 26.3767C71.1327 25.6188 71.5195 24.8463 71.8745 24.0577C72.1167 23.5197 72.3483 22.9677 72.5608 22.4051C72.8159 21.7163 73.0391 21.0156 73.2229 20.3028C73.5667 18.9691 73.7761 17.5692 73.6929 16.1858ZM69.2126 21.0512C67.9894 22.5927 66.1546 23.4562 64.2862 23.465C63.5581 23.4686 62.8248 23.3421 62.1206 23.0756C59.628 22.1318 57.9167 19.5923 57.9167 16.8263C57.9167 16.4805 57.9422 16.1348 57.9936 15.7932C58.3994 13.0907 60.4382 10.8638 63.0074 10.3143C63.4327 10.2233 63.861 10.1802 64.2862 10.1821C66.4839 10.1915 68.5972 11.4005 69.7577 13.4002C71.1425 15.786 70.9162 18.9042 69.2126 21.0512ZM69.8292 13.3962C68.6687 11.3966 66.5554 10.1875 64.3576 10.1782C63.9325 10.1763 63.5042 10.2193 63.0789 10.3103C60.5097 10.8599 58.4709 13.0867 58.065 15.7892C58.0137 16.1308 57.9881 16.4766 57.9881 16.8223C57.9881 19.5883 59.6995 22.1278 62.192 23.0716C62.8962 23.3382 63.6295 23.4646 64.3576 23.461C66.2261 23.4522 68.0609 22.5888 69.2841 21.0472C70.9877 18.9003 71.214 15.782 69.8292 13.3962Z",
    stroke: "#F5BC23",
    strokeWidth: 2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7129 52.2921C17.6147 59.6129 23.8236 62.793 32.6469 59.2641C39.5501 56.503 35.7513 35.2109 47.3523 35.2109C56.5023 35.2109 54.8138 42.2995 64.3451 40.6727",
    stroke: "#004786",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "5 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8032_60291",
    x: 47.8682,
    y: -2.38419e-7,
    width: 35.2428,
    height: 44.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.2,
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.670588 0 0 0 0 0.909804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8032_60291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8032_60291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8032_60291",
    x1: -10.0909,
    y1: 9.99866,
    x2: 183.596,
    y2: 120.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8032_60291",
    x1: -10.5864,
    y1: -3.00195,
    x2: 34.848,
    y2: -1.36354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CDDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8032_60291",
    x1: 50.9008,
    y1: -84.5019,
    x2: -33.0694,
    y2: -11.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CDDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8032_60291",
    x1: 34.0403,
    y1: -29.502,
    x2: 110.231,
    y2: -7.52498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8032_60291",
    x1: 153.05,
    y1: 208.998,
    x2: -29.8095,
    y2: 170.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8032_60291",
    x1: 66.7695,
    y1: 315.498,
    x2: -97.9923,
    y2: 150.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858442,
    stopColor: "#EFFAFE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesAligned);
export default __webpack_public_path__ + "static/media/activities_aligned.83333394a13a018dc882d050cc929eaa.svg";
export { ForwardRef as ReactComponent };